import { render } from "./Water.vue?vue&type=template&id=d8ca5b52"
import script from "./Water.vue?vue&type=script&lang=js"
export * from "./Water.vue?vue&type=script&lang=js"
script.render = render

export default script